import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { Container, Links, Title, Paragraph, TechList } from "./About.styles";

import { getSr } from "../../utils/sr";
import { usePrefersReducedMotion } from "../../hooks";
import { srConfig } from "../../config";
import about from "../../assets/data/aboutData";

const About = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) return;

    const reveal = async () => {
      const sr = await getSr();
      sr.reveal("#about", srConfig());
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(reveal);
    } else {
      setTimeout(reveal, 200);
    }
  }, [prefersReducedMotion]);

  return (
    <section id="about">
      <Container>
        <Title>{about.title}</Title>

        {about.paragraphs.slice(0, 5).map((text, i) => (
          <Paragraph key={`intro-${i}`}>
            <ReactMarkdown
              components={{
                p: ({ node, ...props }) => <>{props.children}</>,
              }}
            >
              {text}
            </ReactMarkdown>
          </Paragraph>
        ))}

        <TechList>
          {about.techStack.map((tech, index) => (
            <li key={index}>{tech}</li>
          ))}
        </TechList>

        {about.paragraphs.slice(5).map((text, i) => (
          <Paragraph key={`end-${i}`}>
            <ReactMarkdown
              components={{
                p: ({ node, ...props }) => <>{props.children}</>,
                a: ({ node, ...props }) => (
                  <Links {...props} target="_blank" rel="noopener noreferrer" />
                ),
              }}
            >
              {text}
            </ReactMarkdown>
          </Paragraph>
        ))}
      </Container>
    </section>
  );
};

export default About;
